export const iconFontAwesomeTravelHotelTruckFieldUn = (
	<i className="fa-solid fa-truck-field-un"></i>
);
